<template>
  <section class="pt-40">
    <b-table v-if="desserts"
             :data="desserts.data"
             ref="table"
             :paginated="false"
             per-page="per_page"
             aria-next-label="Next page"
             aria-previous-label="Previous page"
             aria-page-label="Page"
             aria-current-label="Current page">
      <b-table-column field="name" :label="$t('date')" v-slot="props">
            <span class="col name">
              {{ formatYYYYMMDD(props.row.date) }}
            </span>
      </b-table-column>
      <b-table-column field="agents" :label="$t('amount_usd')" v-slot="props">
        <span class="col common">
          {{ props.row.balanceUSD }}
        </span>
      </b-table-column>
      <b-table-column field="agents" :label="$t('amount_cup')" v-slot="props">
        <span class="col common">
           {{ props.row.balanceCup }}
        </span>
      </b-table-column>
    </b-table>
    <paginate v-if="desserts" :count="desserts.totalRecords"
              :per_page="desserts.itemsPerPage"
              :current-page="desserts.currentPage"
              :total-pages="desserts.totalPages"
              @first="getLast(true)"
              @previous="getBalances(desserts.currentPage - 1,desserts.itemsPerPage)"
              @next="getBalances(desserts.currentPage + 1,desserts.itemsPerPage)"
              @last="getLast"
              @perPage="getBalances(desserts.currentPage,$event)"
              @search="getBalances($event,desserts.itemsPerPage)"
    />
  </section>
</template>
<script>
import {mapActions} from "vuex";
import Paginate from "@/components/list/paginate";

export default {
  name: "LogBalancesDealer",
  components: {Paginate},
  data() {
    return {
      desserts: null
    }
  },
  methods: {
    ...mapActions({
      fetchBalances: 'FETCH_DEALER_BALANCES'
    }),
    formatYYYYMMDD(value) {
      const date = new Date(value)
      if (value && !isNaN(date)) {
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return year + '-' +
            ((month < 10 ? '0' : '') + month) + '-' +
            ((day < 10 ? '0' : '') + day)
      }
      return ''
    },
    getBalances(current, record) {
      let data = {
        currentPage: current,
        recordsPerPage: record,
        id: null,
      };
      return new Promise(resolve => {
        this.fetchBalances(data)
            .then(value => {
              resolve(value)
            })
      })

    },
    getLast(isFirst = false) {
      let page = isFirst ? 1 : this.desserts.totalPages
      this.getBalances(page, this.desserts.itemsPerPage)
    },
  },
  created() {
    this.getBalances(1, 10)
        .then(value => {
          this.desserts = value.result
        })
  }
}
</script>

<style scoped>

</style>